<script lang="ts">
	import { ErrorReportIcon } from "luxedo-comps"
	import { ProgressBar } from "misc-ui"
	import { onDestroy } from "svelte"
	import { Responsive } from "responsive"
	import { Device } from "luxedo-data"
	import { CalibrationController } from "../CalibrationController.svelte"

	interface Props {
		device: Device
	}

	let { device }: Props = $props()

	let calRun = $derived(CalibrationController.runs[device.id])
	let { progress, message, description } = $derived(calRun.progress)

	function retry() {
		CalibrationController.retry(device)
	}

	function openTroubleshooter() {
		CalibrationController.userUnsatisfied(device)
	}

	function cancel() {
		CalibrationController.close(device.id)
	}
</script>

<div class="calibration-top">
	<ErrorReportIcon />
	<ProgressBar width="calc(100% - 8rem)" percentage={progress} />
</div>
<div class="calibration-bottom">
	<h3>
		⚠ {message ?? "An error occurred while calibrating"}
	</h3>
	<p id="error-description">
		{description ??
			`An error occured while calibrating. Given the complexity of calibration, there are many reasons this could have happened. ${Responsive.isMobile ? "Tap" : "Click"} 'Troubleshoot' below to investigate.`}
	</p>
</div>
<div class="button-container">
	<button class="link-button" onclick={cancel}> Cancel </button>
	{#if message === "No camera detected..."}
		<button onclick={retry}>Retry</button>
	{:else}
		<button onclick={openTroubleshooter}>Troubleshoot</button>
	{/if}
</div>

<style>
	.calibration-top :global(svg) {
		height: 8rem;
	}

	h3 {
		color: var(--color-error);
	}
</style>
